import React, { useEffect, useLayoutEffect, useState } from 'react';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import uploadFile from 'src/lib/file-storage/uploadFile';
import ImageThumbnail from './thumbnail/ImageThumbnail';
import PDFThumbnail from './thumbnail/PDFThumbnail';
import { getFileType } from './utils';
const AttachmentItem = ({ data, onRemove, onUploadStart, onUploadSuccess, onUploadFailure, }) => {
    const { loading, error } = data.uploadRequest;
    const [src, setSrc] = useState(data.uploadRequest.data?.publicURL);
    useLayoutEffect(() => {
        if (!src) {
            setSrc(window.URL.createObjectURL(data.file.file));
        }
    }, []);
    const uploadImage = useStableCallback(() => {
        uploadFile(data.file)
            .then(response => {
            if (response?.data) {
                onUploadSuccess(data.id, response.data);
            }
            else {
                onUploadFailure(data.id, new Error('Failed to upload the image'));
            }
        })
            .catch(err => {
            onUploadFailure(data.id, err);
        });
    });
    useEffect(() => {
        if (!data.uploadRequest.data) {
            uploadImage();
        }
    }, []);
    const handleRetry = useStableCallback(() => {
        onUploadStart(data.id);
        uploadImage();
    });
    const type = getFileType(src ?? '');
    const props = {
        src,
        onRemove() {
            onRemove(data.id);
        },
        loading,
        error,
        onRetry: handleRetry
    };
    if (type === FileType.PDF) {
        return React.createElement(PDFThumbnail, { ...props });
    }
    return React.createElement(ImageThumbnail, { ...props });
};
export default AttachmentItem;
